// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { LAST_NAME_ERROR } from './constants';

export function setLastNameError(data) {
  return {
    type: LAST_NAME_ERROR,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LAST_NAME_ERROR:
      return {
        ...state,
        lastNameError: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/setLastNameError.js